import React from 'react';
import { IIconProps } from './utils';

export const WarningOutlined = ({
  fill = 'currentColor', height = 16, width = 16, ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 16 16" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M6.64549 2.77728C7.23593 1.74091 8.7644 1.74091 9.35484 2.77728L14.4696 11.7549C15.0434 12.7622 14.2965 14 13.1149 14H2.88542C1.7038 14 0.956899 12.7622 1.53074 11.7549L6.64549 2.77728Z"
      stroke={fill}
      strokeWidth="1.33333"
    />
    <path
      d="M8.00049 10.667C8.58937 10.6673 9.06689 11.1445 9.06689 11.7334C9.06686 12.3223 8.58935 12.7995 8.00049 12.7998C7.41141 12.7998 6.93314 12.3225 6.93311 11.7334C6.93311 11.1443 7.41138 10.667 8.00049 10.667ZM8.00049 4.5332C8.44198 4.53347 8.80012 4.89149 8.80029 5.33301V9.06641C8.80026 9.50804 8.44207 9.86595 8.00049 9.86621C7.55868 9.86621 7.20072 9.5082 7.20068 9.06641V5.33301C7.20086 4.89133 7.55877 4.5332 8.00049 4.5332Z"
      fill={fill}
    />
  </svg>
);

